import React from 'react';
import clsx from 'clsx';
import styles from './Form.module.scss';

/**
 * Form
 *
 * SPA-first wrapper around the native <form> element.
 * Always prevents default browser submission.
 *
 * Responsibilities:
 * - Prevent native submit behavior
 * - Provide consistent vertical spacing
 * - Provide a single submission boundary
 *
 * Props:
 * - onSubmit: function (optional)
 * - disabled: boolean (optional)
 * - className: string (optional)
 * - children: React nodes
 *
 * All other props are passed to the <form> element.
 */
const Form = ({
  onSubmit,
  disabled = false,
  className,
  children,
  ...rest
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();

    if (disabled) {
      return;
    }

    if (onSubmit) {
      onSubmit(e);
    }
  };

  return (
    <form
      {...rest}
      onSubmit={handleSubmit}
      className={clsx(styles.form, disabled && styles.disabled, className)}
      aria-disabled={disabled || undefined}
    >
      {children}
    </form>
  );
};

export default Form;
